import { SendGridUserValues } from "./types";

export const testUserToSendGridValuesMap: Record<string, SendGridUserValues> = {
  "svc-engineering-devs+test__help-center-free-account@twilio.com": {
    userId: "2133496358",
    username: "svc-engineering-devs+test__help-center-free-account@twilio.com",
    supportPackage: {
      emailSupportPackage: "sg_email_pkg_free",
      marketingSupportPackage: "sg_mktg_pkg_free",
    },
  },
  "svc-engineering-devs+test__help-center-chat-account@twilio.com": {
    userId: "2133497096",
    username: "svc-engineering-devs+test__help-center-chat-account@twilio.com",
    supportPackage: {
      emailSupportPackage: "sg_email_pkg_essentials",
      marketingSupportPackage: "sg_mktg_pkg_advanced",
    },
  },
  "svc-engineering-devs+test__help-center-all@twilio.com": {
    userId: "2133505580",
    username: "svc-engineering-devs+test__help-center-all@twilio.com",
    supportPackage: {
      emailSupportPackage: "sg_email_pkg_essentials",
      marketingSupportPackage: "sg_mktg_pkg_advanced",
    },
  },
};

const WISE_OWL_CHAT_TAG = (chatId: string): string =>
  `hca_sendgrid_help_center_chat_id__${chatId}`;

export default {
  testUserToSendGridValuesMap,
  WISE_OWL_CHAT_TAG,
};
